module.exports = {
  InsureNo: '投保单号',
  PolicyNo: '保单号',
  TheInsured: '被保险人',
  DateOfShipment: '起运日期',
  PlaceOfOrigin: '起运地',
  Destination: '目的地',
  BillOfLoadingNo: '提单号',
  Premium: '保费',
  SubmissionTime: '提交时间',
  DeliveryTime: '出单时间',
  DeliveryStatus: '出单状态',
  Operation: '操作',
  EditPolicy: '编辑保单',
  DeletePolicy: '删除保单',
  DownloadPolicy: '下载保单',
  CancellationOfPolicy: '注销保单',
  ReIssuePolicy: '重出保单',
  InvoiceNo: '发票号',
  PlaceOfOriginForSea: '海港起运地',
  PlaceOfOriginForAir: '空港起运地',
  SeaportDestination: '海港目的地',
  AirportDestination: '空港目的地',
  N1CompleteInsuranceInformation: '1填写保单信息',
  N3PreviewAndConfirm: '3预览确认',
  Insured: '被保险人',
  EmailRecipient: '邮件接收人',
  GoodsCategory: '货物大类',
  GoodsName: '货物名称',
  MarksAndNumbers: '唛头',
  BillOfLadingNumber: '提单号',
  BillOfLadingDate: '提单日期',
  InvoiceNumber: '发票号',
  ContractNumber: '合同号',
  VesselVoyagevehiclePlateNumberflightNumber: '船名航次/车牌号/航班号',
  TransportationType: '运输类型',
  Domestic: '国内',
  Import: '进口',
  Export: '出口',
  TransportationMode: '运输方式',
  InlandTransportationTools: '内陆运输工具',
  PlaceOfDepartureport: '起运地（港）',
  DepartureDate: '起运日期',
  TransitPlaceport: '中转地（港）',
  Destinationport: '目的地（港）',
  InlandStartingPoint: '内陆起运地',
  TradeTerms: '贸易条款',
  InvoiceAmount: '发票金额',
  MainInsurance: '主险',
  LetterOfCreditConditionNumber: '信用证条件号',
  ClaimsAgentPoint: '理赔代理点',
  Insured2: '被保险人：',
  PolicyHolder: '投保人：',
  EndDateOfInsurance: '终保日期：',
  DateOfInsurance: '投保日期：',
  DateOfEntry: '录入日期：',
  MainClause: '主条款：',
  GoodsName2: '货物名称：',
  InsurancePremium: '保单保费：',
  InsuranceAmounttotalLimit: '保额/总限额：',
  FinalRate: '最终费率%：',
  AddProportion: '加乗比例%：',
  InsuranceApplicationNumber: '投保单号：',
  PolicyStatus: '保单状态：',
  InsuranceStartDate: '起保日期：',
  ReviewDate: '复核日期：',
  UnderwritingDate: '核保日期：',
  CompleteInsuranceInformation: '填写保单信息',
  Inquire: '询价',
  PreviewAndConfirm: '预览确认',
  InsuranceCompleted: '投保完成',
  CancellationReason: '注销原因',
  PolicyHolderInformation: '投保人信息',
  SameAsPolicyHolder: '同投保人',
  GoodsInformation: '货物信息',
  TransportationInformation: '运输信息',
  InsuranceAmountInformation: '保险金额信息',
  InsuranceConditions: '保险条件',
  FreightInsurance: '货运险',
  WPA: '水渍险',
  FPA: '平安险',
  AllRiskForRefrigeratedGoods: '冷藏一切险',
  RefrigeratedInsurance: '冷藏险',
  OtherInformation: '其他信息',
  InsuranceInstructions: '投保说明',
  TheInstitutionsWithTechnicalLtd: '本平台所列示的保险产品由保险机构提供销售，由东京海上日动火灾保险（中国）有限公司提供技术服务。',
  PremiumAmount: '保费金额',
  ShanghaiStorageAndTransportationLtd: '上海经贸山九储运有限公司',
  SuccessfullyInsured: '投保成功！',
  PolicyNumber: '保单号：',
  TemporarySave: '暂存',
  PreviewAndContinue: '预览并继续',
  Back: '返回',
  PurchaseInsurance: '投保',
  Submitted: '已提交',
  SavedSuccessfully: '暂存成功',
  PleaseNameOfTheCompany: '请填写货主企业名称！',
  PleaseEmailSeparateMultipleSemicolons: '请填写邮件接收人！多个邮件接收人请用英文分号分割！',
  PleaseGeneralCategoryOfGoods: '请填写货物大类！',
  PleaseTheNameOfGoods: '请填写货物名称！',
  PleaseInTheInvoiceNumber: '请填写输入发票号',
  TheShippingMarkCannotCharacters: '唛头长度不能超过3000位！',
  TheCannotExceed40Characters: '发票号码不能超过40位！',
  BillNumberCannotExceedCharacters: '提单号不能超过100位！',
  ContractCannotExceed100Characters: '合同号不能超过100位！',
  PleaseVoyageNumberLicenseNumber: '请输入船名航次/车牌号/航班号',
  PleaseEnterTheTransportationType: '请输入运输类型',
  PleaseEnterTheTransportationMode: '请输入运输方式',
  PleasePlaceOfDepartureport: '请输入起运地（港）',
  PleaseEnterTheDestinationport: '请输入目的地（港）',
  PleaseEnterTheDepartureDate: '请输入起运日期',
  PleaseEnterTheTradeTerms: '请输入贸易条款！',
  PleaseEnterTheInvoiceAmount: '请输入发票金额！',
  PleaseEnterTheInvoiceCurrency: '请输入发票金额币种',
  PleaseTheClaimAgencyPoint: '请输入理赔代理点',
  PleaseAgreeToTheNotice: '请阅读并同意《客户告知书》！',
  PolicyManagement: '保单管理',
  QuickSearchPolicyNumber: '快捷检索:保单号',
  Cancellation: '注销',
  TotalPremium: '总保费：',
  PleaseInTheCancellationReason: '请填写注销理由',
  YouPermissionToEditPolicy: '您没有权限编辑保单',
  YouPermissionToDeletePolicy: '您没有权限删除保单',
  DeletingThePolicyRecordContinue: '删除后将清除保单记录，是否继续？',
  Confirm: '确认',
  InsurancePolicyNumber: '投保单号',
  Deleted: '已删除',
  YouPermissionToCancelPolicy: '您没有权限注销保单',
  PolicyNumber2: '保单号',
  Canceled: '已注销',
  YouPermissionToReissuePolicy: '您没有权限重出保单',
  YouBeforeAndCannotAgain: '您已重出过，不允许重复重出！',
  InsuranceInstructionsTip: '我已认真阅读并同意 《客户告知书》, 《投保声明》, 《平台使用协议》, 《保险条款》 等内容，了解并接受包括有关责任条款、免除责任险条款、承保货物品类限制、承保货值限制等约定。',
  InsuranceAgent: '保险代理',
  InsuranceCompany: '保险公司',
  InvoiceCurrency: '发票币种',
  InsuranceAmount: '投保金额',
  InsuranceCurrency: '投保币种',
  PremiumCurrency: '保费币种',
  Rate: '费率',
  Waybillno: '运(主)单号',
  InsureOrderUser: '投保单操作',
  PolicyUser: '保单操作',
  ReconciliationUser: '对账操作',
  PolicySyncStatus: '保单同步状态',
  PremiumSyncStatus: '保费同步状态',
  StartDate: '起保日期',
  EndDate: '终保日期',
  FreightInsuranceFirstPage: '货运险首页',
  LiabilityInsuranceHomepage: '责任险首页',
  LiabilityInsurance: '责任险',
  BillingManagement: '账单管理',
  Scanning: '速览',
  Specification: '特别说明',
  ServiceAdvantages: '服务优势',
  InsuranceType: '保险险种',
  BillQuery: '账单查询',
  InvoiceDownload: '发票下载',
  ViewPolicy: '查看保单',
  PolicyDownload: '保单下载',
  AddInquiryQuestionnaire: '新增询价问卷',
  EditOrViewQuestionnaire: '编辑/查看问卷',
  QuestionnaireStatus: '问卷状态',
  PolicyStatus2: '保单状态',
  LiabilityInsuranceInquiry: '货运代理责任保险询价',
  InquiryForQuestionnaireContent: '*本问卷内容仅适用与责任险险询价，沃行和第三方公司将严格保密；',
  AfterFillingQuestionnaire: '*填写本问卷后，第三方预计于24小时内联系留存电话；',
  ServiceProviderSelection: '服务商选择：',
  ApplicantInformation: '申请人信息：',
  RegisteredAndBusiness: '公司注册名称和营业名称(如有)：',
  InquiryQuestionnaire: '询价问卷',
  ServiceProviderReply: '服务商回复',
  ServiceProviderReply2: '供应商回复',
  RegisteredName: '注册名称',
  RegisteredAddress: '注册地址',
  BusinessName: '营业名称',
  BusinessAddress: '营业地址',
  RecoveryTime: '回复时间：',
  ReplyContent: '回复内容：',
  ExistInsuranceReocordContinue: '当前提单已经存在投保记录，是否继续',
  TheInsuranceHasExist: '已投保，不能重复投保',
  CreatedNewInsureForm: '创建新的投保单',
  ToViewOriginalApplication: '查看原有投保单，请前往',
  Insurance: '保险',
  Tab: '页签',
  EditViewInsuranceForm: '编辑/查看投保单',
  Deductible: '免赔额',
  InsuranceCoverage: '保险范围',
  SpecialInstructions: '特殊说明',
  ClaimsService: '理赔服务',
  ServiceProviderIntroduction: '服务商介绍',
  SpecialCargo: '特殊货物',
  CargoExclusion: '除外货物',
  SpecialAgreement: '特别约定',
  ChooseServiceProvider: '选择服务商',
  ViewInsurancePolicy: '保险页查看投保单',
  RememberOperationDirectly: '记住本次操作，下次直接投保',
  ProductValue: '产品价值',
  Charges: '收费标准',
  MaximumIndemnityNorm: '赔偿限额',
  SupplierResponse: '供应商回复',
  UploadedFileUnRemove: '已上传的文件不允许移除！',
  NoCorrespondingTemplate: '未找到对应模板！',
  NotAllowDeleteSubmited: '【已提交，已出单】的投保记录不允许删除，请重新选择！',
  OnlyFileDocAndPdf: '只能上传后缀名为【doc,docx,pdf】的文件，请重新选择！',
  ToInsure: '投保:',
  FillInsuranceInformation: '填写投保信息',
  ClickToDownloadTemplate: '点击下载模板，按照格式填写',
  DragFile: '将文件拖到此处，或',
  ClickToUpload: '点击上传'
}
